export const iconFontAwesomeTransportationTaxi = (
	<i className="fa-solid fa-taxi"></i>
);
